class MobileNavShortcuts extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
    document.addEventListener('pointerdown', this.onDocumentPointerDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('pointerdown', this.onDocumentPointerDown);
  }

  onClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-mobile-nav-target]');
    if (!(trigger instanceof HTMLButtonElement) || !this.contains(trigger)) return;

    event.preventDefault();
    const target = trigger.dataset.mobileNavTarget;
    if (!target) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    this.closeAll();

    if (!isOpen) {
      const panel = this.querySelector(`[data-mobile-nav-panel="${CSS.escape(target)}"]`);
      if (panel instanceof HTMLElement) {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
  };

  onKeydown = (event) => {
    if (event.key !== 'Escape') return;
    this.closeAll();
  };

  onDocumentPointerDown = (event) => {
    if (!(event.target instanceof Node)) return;
    if (!this.contains(event.target)) this.closeAll();
  };

  closeAll() {
    for (const trigger of this.querySelectorAll('[data-mobile-nav-target]')) {
      if (trigger instanceof HTMLButtonElement) trigger.setAttribute('aria-expanded', 'false');
    }

    for (const panel of this.querySelectorAll('[data-mobile-nav-panel]')) {
      if (panel instanceof HTMLElement) panel.hidden = true;
    }
  }
}

if (!customElements.get('mobile-nav-shortcuts')) {
  customElements.define('mobile-nav-shortcuts', MobileNavShortcuts);
}
